import React from 'react';
import { Coffee, UtensilsCrossed } from 'lucide-react';

interface MealPlan {
  breakfast: boolean;
  lunch: boolean;
  dinner: boolean;
}

interface DayItinerary {
  id: number;
  dayNumber: number;
  title: string;
  description: string;
  activities: string[];
  meals: MealPlan;
  accommodation: string;
}

interface ItineraryProps {
  itinerary?: DayItinerary[];
}

export default function Itinerary({ itinerary = [] }: ItineraryProps) {
  if (!itinerary || itinerary.length === 0) {
    return (
      <div className="text-center p-4 bg-gray-50 rounded-lg">
        <p className="text-gray-500">Aucun itinéraire disponible</p>
      </div>
    );
  }

  const getMealsIcons = (meals: MealPlan) => {
    const icons = [];
    if (meals.breakfast) icons.push('Petit-déjeuner');
    if (meals.lunch) icons.push('Déjeuner');
    if (meals.dinner) icons.push('Dîner');
    return icons;
  };

  return (
    <div className="space-y-8">
      {itinerary.map((day) => (
        <div key={day.id} className="border rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold">Jour {day.dayNumber}: {day.title}</h3>
            <div className="flex items-center space-x-4">
              {getMealsIcons(day.meals).map((meal, index) => (
                <div key={index} className="flex items-center text-gray-600">
                  <UtensilsCrossed className="w-5 h-5 mr-1" />
                  <span className="text-sm">{meal}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="text-gray-600 mb-4">{day.description}</p>

          {day.activities.length > 0 && (
            <div className="mb-4">
              <h4 className="font-medium mb-2">Activités :</h4>
              <ul className="list-disc list-inside space-y-1">
                {day.activities.map((activity, index) => (
                  <li key={index} className="text-gray-600">{activity}</li>
                ))}
              </ul>
            </div>
          )}

          {day.accommodation && (
            <div className="mt-4 pt-4 border-t">
              <h4 className="font-medium mb-2">Hébergement :</h4>
              <p className="text-gray-600">{day.accommodation}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}